import { AuditEntityFieldDefinition } from 'O3_audit';
import enAuditFields from './locales/en/audit-fields.json';
import roAuditFields from './locales/ro/audit-fields.json';

export const APPOINTMENT_AUDIT_DEFINITIONS: AuditEntityFieldDefinition[] = [
  {
    entityType: 'Appointment',
    localeKeyOverrides: {
      // `cancelationReasonId` (the catalog reason) and `cancelationReason`
      // (the free-text detail) would both strip to the same label.
      cancelationReason: 'audit_shared:snapshotFields.cancelationReasonDetails',
    },
  },
];

export const APPOINTMENT_AUDIT_TRANSLATIONS = {
  en: enAuditFields as Record<string, unknown>,
  ro: roAuditFields as Record<string, unknown>,
};
